exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Search-module__container___1mIP8{display:grid;align-items:center;justify-items:center;grid-template-columns:1fr 40px;width:200px;height:-moz-max-content;height:max-content}.Search-module__container___1mIP8 input{grid-column:1/3;grid-row:1}.Search-module__container___1mIP8 svg{grid-column:2;grid-row:1;color:#0827e9}.Search-module__input___2sgGf{border-radius:22px;border:1px solid #ececec;padding:6px .75rem;font-size:14px;background-color:#ececec;color:#0827e9}.Search-module__input___2sgGf::-moz-placeholder{color:#b4bac3}.Search-module__input___2sgGf:-ms-input-placeholder{color:#b4bac3}.Search-module__input___2sgGf::placeholder{color:#b4bac3}", ""]);

// exports
exports.locals = {
	"container": "Search-module__container___1mIP8",
	"input": "Search-module__input___2sgGf"
};